import Image from 'next/image';

interface ICompanyLogo {
  title: string;
  logo: string;
  content: string;
}

export const CompanyLogo = ({ title, logo, content }: ICompanyLogo) => {
  return (
    <div className="flex flex-col md:flex-row mb-8">
      <div
        className="flex-grow my-3"
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <div className="flex-none w-64 mx-auto grid place-content-center">
        <Image
          src={`/img/partners/${logo}.png`}
          alt={title}
          width={251}
          height={181}
        />
      </div>
    </div>
  );
};
